<template>
  <div class="stars" :class="starsType">
    <span class="star" v-for="star in starClass" :class="star"></span>
  </div>
</template>

<script type="text/ecmascript-6">
  const LENGTH = 5;
  const CLS_ON = 'on';
  const CLS_OFF = 'off';
  const CLS_HALF = 'half';
  export default{
    props: ['size', 'score'],
    computed: {
      starClass() {
        let stars = [];
        let score = Math.floor(this.score * 2) / 2;
        let isHalf = score % 1 !== 0;
        for (let i = 0; i < Math.floor(score); i++) {
          stars.push(CLS_ON);
        }
        if (isHalf) {
          stars.push(CLS_HALF);
        }
        while (stars.length < LENGTH) {
          stars.push(CLS_OFF);
        }
        return stars;
      },
      starsType() {
        return 'stars-' + parseInt(this.size);
      }
    }
  };
</script>

<style rel="stylesheet/stylus" lang="stylus">
  @import "../../common/stylus/mixin.styl";
  .stars
    display:flex
    flex-direction:row
    justify-content:center
    .star
      display:block

  .stars-24
    .star
      width:10px
      height:10px
    .star + .star
      margin-left:3px
    star-image(24)

  .stars-36
    .star
      width:15px
      height:15px
    .star + .star
      margin-left:6px
    star-image(36)

  .stars-48
    .star
      width:20px
      height:20px
    .star + .star
      margin-left:22px
    star-image(48)
</style>



// WEBPACK FOOTER //
// stars.vue?521d7a4c